import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiClientInterface } from '../../client/api/api-client.interface';
import { IdInterface, ProductInterface, SelectedProductInterface } from '../data';
import { Transaction } from '../transaction/transaction';
import { TransactionRequestInterface } from '../transaction/transaction-request.interface';
import { ProductsbyOrderTypeInterface } from '../data/productsbyordertype.interface';

@Injectable()
export class ProductApiRepository {
    constructor(private apiClient: ApiClientInterface, private transactionRequest: TransactionRequestInterface) {}

    load(): Observable<Transaction<ProductInterface[]>> {
        return this.transactionRequest.wrap(this.apiClient.getProducts());
    }

    loadMine(contractCode: IdInterface): Observable<Transaction<ProductInterface[]>> {
        return this.transactionRequest.wrap(this.apiClient.getMyProducts(contractCode));
    }

    loadDetail(productCode: IdInterface): Observable<Transaction<ProductInterface>> {
        return this.transactionRequest.wrap(this.apiClient.getProduct(productCode));
    }

    loadDocument(productCode: IdInterface): Observable<Transaction<string>> {
        return this.transactionRequest.wrap(this.apiClient.getProductDocument(productCode));
    }

    loadSelected(contractCode: IdInterface, clientCode?: IdInterface): Observable<Transaction<SelectedProductInterface[]>> {
        return this.transactionRequest.wrap(this.apiClient.getSelectedProducts(contractCode, clientCode));
    }

    addSelected(contractCode: IdInterface, products: ProductInterface[]): Observable<Transaction<SelectedProductInterface[]>> {
        return this.transactionRequest.wrap(this.apiClient.addSelectedProducts(contractCode, products));
    }

    checkSelected(contractCode: IdInterface, products: SelectedProductInterface[]): Observable<Transaction<SelectedProductInterface[]>> {
        return this.transactionRequest.wrap(this.apiClient.checkSelectedProducts(contractCode, products));
    }

    updateSelected(contractCode: IdInterface, products: SelectedProductInterface[]): Observable<Transaction<void>> {
        return new Observable((observer) => {
            this.transactionRequest.wrap(this.apiClient.updateSelectedProducts(contractCode, products)).subscribe((transaction) => {
                if (transaction.isSuccess) {
                    observer.next(Transaction.success());
                } else {
                    observer.next(Transaction.error(transaction.error));
                }

                observer.complete();
            });
        });
    }

    removeSelected(product: SelectedProductInterface): Observable<Transaction<void>> {
        return new Observable((observer) => {
            this.transactionRequest.wrap(this.apiClient.removeSelectedProduct(product)).subscribe((transaction) => {
                if (transaction.isSuccess) {
                    observer.next(Transaction.success());
                } else {
                    observer.next(Transaction.error(transaction.error));
                }

                observer.complete();
            });
        });
    }


    loadByOrderType(portfolioCode: IdInterface, clientCode?: IdInterface, distributionChannel?: string[], orderType?: string , riskLevel?: string): Observable<Transaction<ProductInterface[]>> {
        return this.transactionRequest.wrap(this.apiClient.getProductsByOrderType(portfolioCode, clientCode, distributionChannel, orderType, riskLevel));
    }

    loadByOrderTypeClient(portfolioCode: IdInterface, clientCode?: IdInterface, distributionChannel?: string[], orderType?: string , riskLevel?: string): Observable<Transaction<ProductInterface[]>> {
        return this.transactionRequest.wrap(this.apiClient.getProductsByOrderTypeClient(portfolioCode, clientCode, distributionChannel, orderType, riskLevel));
    }
}
